import { Component, Input } from '@angular/core';
import { Program, ProgramLogisticsDisplayOptions, Session } from 'globals/store/programs.data';
import { Dictionary } from '@ngrx/entity';
import { LabelObject } from 'globals/store/events.data';
import publicHelpers from '../../helpers/public-helpers';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { TagPanelData } from 'globals/store/tags.data';
import { LogisticsEvent } from 'globals/store/logistics.data';
import { CommonModule } from '@angular/common';
import { ExpandingWrapperComponent } from 'src/app/components/wrappers/expanding-wrapper.component';
import { LabelsViewComponent } from 'src/app/components/label-marker/labels-view.component';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { AssetLinkComponent } from '../assets/asset-link.component';
import { PhotoComponent } from 'src/app/components/photo';
import { GreyCardComponent } from 'src/app/components/cards/grey-card.component';
import { TagPanelComponent } from '../manage/tag-panel.component';
import { TagPanelViewComponent } from '../manage/tag-panel-view.component';
import { ProgramDayDate } from 'src/app/services/pipes/programs.pipe';
import { StagingRequestsComponent } from '../manage/staging-requests.component';
import { FileLinkComponent } from 'src/app/components/file-handler/file-link.component';
import { PerformerCardComponent } from 'src/app/components/cards/performer-card.component';
import { SubtitleWrapperComponent } from 'src/app/components/wrappers/subtitle-wrapper.component';
import { InformablePublicComponent } from 'src/app/components/informable/informable.public.component';
import { IdsToItemsPipe } from 'src/app/services/pipes/sortByIds.pipe';
import { StagingRequestsPipe } from 'src/app/services/pipes/stagingRequests.pipe';
import { justTimeToHHMM } from 'globals/helpers/helpers';
import { JustTimeToHHMM } from 'src/app/services/pipes/justTimeToHHMM.pipe';
import { IdsToTagDataPipe } from 'src/app/services/pipes/idsToTagData.pipe';
import { OnSessionsViewComponent } from './on-sessions-view.component';

@Component({
    selector: 'logistics-view',
    animations: [
        trigger('drop', [
            state('expand', style({ height: '*' })),
            state('collapse, undefined, void', style({ height: '0', overflow: 'hidden', padding: 0 })),
            transition('* => *', [animate('300ms')]),
            transition('void => *', [animate('0ms')])
        ])
    ],
    templateUrl: './logistics-view.html',
    styleUrls: ['../program/program.logistics.scss'],
    standalone: true,
    imports: [CommonModule, ExpandingWrapperComponent, StagingRequestsPipe, OnSessionsViewComponent, JustTimeToHHMM, IdsToTagDataPipe, IdsToItemsPipe, InformablePublicComponent, SubtitleWrapperComponent, LabelsViewComponent, IconComponent, AssetLinkComponent, PhotoComponent, GreyCardComponent, TagPanelViewComponent, ProgramDayDate, StagingRequestsComponent, FileLinkComponent, PerformerCardComponent]
})
export class LogisticsViewComponent<E extends LogisticsEvent>  {

  @Input() logisticsEvent: E
  @Input() canViewStagingRequests: boolean
  @Input() programs: Program[]
  @Input() program_labels: LabelObject = {}
  @Input() session_labels: LabelObject = {}
  @Input() excludedFieldIds: string[] = []
  @Input() exhibitorStandIdsByProgramId: Dictionary<string[]> = {}
  @Input() tagDataMap: Dictionary<TagPanelData> = {}
  @Input() sessionMap: Dictionary<Session> = {}

  helpers = publicHelpers
  expandedStates: Dictionary<boolean> = {}
  DOIds = ProgramLogisticsDisplayOptions

  
  trackByIndex(index) {
    return index
  }

  trackById<T extends { id?: string }>(_, item: T) {
    return item.id
  }

  trackBySelf<T>(_, item: T) {
    return item // in case of primitive, compares primitives.  Objects compare references
  }

  expandProgram(program: Program) {
    this.expandedStates[program.id + ':room'] = true
    program.sessions.forEach(programDay => programDay.sessions.forEach(s => this.expandedStates[`${program.id}:${s}`] = true))
    program.setupIds.forEach(setupId => this.expandedStates[`${program.id}:${setupId}`] = true)
  }

  collapseProgram(program: Program) {
    this.expandedStates[program.id + ':room'] = false
    program.sessions.forEach(programDay => programDay.sessions.forEach(s => this.expandedStates[`${program.id}:${s}`] = false))
    program.setupIds.forEach(setupId => this.expandedStates[`${program.id}:${setupId}`] = false)
  }

  expandAll() {
    console.log("Expand all")
    this.programs.forEach(p => this.expandedStates[p.id] = true)
    this.programs.forEach(this.expandProgram.bind(this))
  }

  collapseAll() {
    console.log("Collapse all")
    this.programs.forEach(p => this.expandedStates[p.id] = false)
    this.programs.forEach(this.collapseProgram.bind(this))
  }

  


}

